import Container from '../../../UI/Container/Container';

import { Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = (props) => {
  return (
    <Container>
      <Typography variant='h5' component='h2' sx={{ fontWeight: 'bold', mb: '2rem' }}>
        What does The Pre-100 Club do?
      </Typography>
      <div>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>We help members in the society form mastermind groups.</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              We match like-minded aspiring entrepreneurs within the society, into groups of 4, using our proven system
              in The 100 Club. These groups will meet biweekly, in order for them to support each other in staying
              accountable, sharing advice, and networking to build their business.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel3a-content' id='panel3a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>
              Members of The Pre-100 Club will get mentorship from The 100 Club.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Mastermind groups will get mentorship from members of The 100 Club, who are already successful
              entrepreneurs that are running their own businesses. Members of The 100 Club range from creative agency
              owners to VC-funded tech startups.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </Container>
  );
};

export default FAQ;
